import { autoinject, bindable, PLATFORM } from 'aurelia-framework';

import {
	ClassicPanelDialog,
	ClassicPanelDialogModel,
} from '~/components/classic-panel/classic-panel-dialog';
import { ShortcutKey } from '~/constants';
import { FormModel } from '~/models/form-model';
import FormModelUtils from '~/utils/form-model-utils';
import { HelpFileUtils } from '~/utils/help-file-utils';
import { KeyboardShortcut } from '~/utils/keyboard-shortcut';

export interface PaymentOptionalItemsDialogModel
	extends ClassicPanelDialogModel {
	formModel?: FormModel;
	isReadOnly?: boolean;
}

@autoinject
export class PaymentOptionalItemsDialog extends ClassicPanelDialog<PaymentOptionalItemsDialogModel> {
	private static readonly BENEFITS_PAYMENTS_CENTRE_FUNCTION_NAME =
		'benefits-payments-centre';

	private origFormModel: FormModel;

	@bindable
	private closeButtonText: string;

	constructor(...rest) {
		super(...rest);
		PLATFORM.moduleName('./payment-optional-items-dialog');
	}

	/**
	 * @override
	 */
	protected attachKeyboardShortcuts() {
		super.attachKeyboardShortcuts();
		KeyboardShortcut.subscribe(this, ShortcutKey.HelpFile, () =>
			this.openHelpFile(),
		);
	}

	/**
	 * Used by view
	 */
	private openHelpFile(): void {
		HelpFileUtils.openHelpFileIfPossible(
			PaymentOptionalItemsDialog.BENEFITS_PAYMENTS_CENTRE_FUNCTION_NAME,
			undefined,
		);
	}

	public attached(): void {
		super.attached();
		this.origFormModel = FormModelUtils.cloneModel(this.model.formModel);
		this.classicPanel.formModel = this.model.formModel;
		if (this.model.isReadOnly) {
			this.closeButtonText = this.i18n.tr('clickable-elements.close');
		} else {
			this.closeButtonText = this.i18n.tr('clickable-elements.cancel');
		}
	}

	/**
	 * @override
	 */
	protected save() {
		if (!this.checkIfCanSaveAndThrowError()) {
			return;
		}

		this.setIsSaving(true);
		this.controller.ok();
		this.setIsSaving(false);
	}

	/**
	 * @override
	 */
	protected close() {
		this.classicPanel
			.promptToClosePanelIfChangedAndClearValidation()
			.then(() => {
				// Reset formModel fields back to original formModel values
				// set at attacted
				for (const [key, field] of Object.entries(
					this.model.formModel.fields,
				)) {
					field.value = this.origFormModel.fields[key].value;
				}

				this.controller.ok();
			});
	}
}
